import {Module} from 'vuex'
import {state} from './state'
import {IAuthentificationStateModel, IRootStateModel} from './../../interfaces'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'

const authentification: Module<IAuthentificationStateModel, IRootStateModel> = {
    state,
    mutations,
    getters,
    actions
}

export default authentification;